import { render, staticRenderFns } from "./trunNum.vue?vue&type=template&id=5a3fcd77&scoped=true&"
import script from "./trunNum.vue?vue&type=script&lang=js&"
export * from "./trunNum.vue?vue&type=script&lang=js&"
import style0 from "./trunNum.vue?vue&type=style&index=0&id=5a3fcd77&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3fcd77",
  null
  
)

export default component.exports